import type { Subscription } from "@/types/podcast";
import PodcastGrid from "./PodcastGrid";
import { Skeleton } from "@/components/ui/skeleton";

interface SubscriptionsSectionProps {
  subscriptions: Subscription[];
  isLoading: boolean;
}

export default function SubscriptionsSection({
  subscriptions,
  isLoading,
}: SubscriptionsSectionProps) {
  if (isLoading) {
    return (
      <div>
        <Skeleton className="mb-3 h-5 w-40" />
        <PodcastGrid podcasts={[]} isLoading />
      </div>
    );
  }

  if (subscriptions.length === 0) return null;

  return (
    <div>
      <h2 className="mb-3 text-sm font-semibold text-gray-700">
        Your Podcasts ({subscriptions.length})
      </h2>
      <PodcastGrid podcasts={subscriptions} />
    </div>
  );
}
